import AccountSearch from 'components/AccountSearch'
import SimpleFileFolder from 'components/SimpleFileFolder'
import DateInput from '../../../../../../components/DateInput'
import SectionHeader from '../../Header/SectionHeader'
import formatters from 'lib/formatters'
import styles from '../styles.css'
import { DRF_TYPE, MONTHS } from '../constant'
import { Link } from 'react-router-dom'
import { IconRecurring } from '../../../../../../components/Icons/IconRecurring'
import { useMemo } from 'react'
import { calculateEndDateRange } from '../utils.js'

export default function WriteFormOne({
  onUploadClick,
  files,
  onDeleteClick,
  form,
  updateForm,
  formDisabled,
  handleAccountSelect,
  recurringFormDisabled,
  handleRecurringUpdate,
  handleRecurringEndDateBlur,
  currentDrfRecurring,
  nextStatus,
  lockedForEdit,
  drfType,
  setPayNowRecurring,
  endDate,
}) {
  const disableFields = formDisabled && ['admin_wrapped_up'].includes(nextStatus)

  const getRecurringColor = (area) => {
    if (drfType == DRF_TYPE.SCHEDULED) {
      if (area === 'body') {
        return styles.recurringDistributionSection
      } else {
        return styles.recurringHeader
      }
    }
  }

  // disable form if valid end date is there
  const isValidEndDate = form.status == 'recurring_written' ? endDate != null : true

  const endDateRange = useMemo(() => calculateEndDateRange(form?.recurringDistribution), [form?.recurringDistribution?.startMonth, form?.recurringDistribution?.dayRepeats])

  const shouldShowReissuanceFee = () => {
    if (!form.account || !form.account.number) return false
    const firstLetter = form.account.number.charAt(0).toUpperCase()
    return ['D', 'J', 'N', 'T'].includes(firstLetter)
  }

  return (
    <div className={styles.sectionOne}>
      {/* recurring section  */}
      {drfType != DRF_TYPE.STANDARD && (drfType == DRF_TYPE.TEMPLATE || currentDrfRecurring) && (
        <section className={`${styles.cardMarginBot} ${getRecurringColor('body')}`}>
          {isValidEndDate && (formDisabled || recurringFormDisabled || drfType == DRF_TYPE.SCHEDULED) && <div className={styles.disabledMask}></div>}
          <SectionHeader title={'Recurring'} icon={<IconRecurring />} className={getRecurringColor()} />
          {/* if template don't show purple color */}
          <section className={`${styles.sectionNoMargin} ${getRecurringColor('body')}`}>
            {form.templateId && (
              <section style={{ marginBottom: '1.75rem' }}>
                <Link to={`/distributions/${form.templateId}`} className={styles.recurringViewLink} target="_blank" referrerPolicy="no-referrer">
                  View this Recurring DRF Template: ID {form.templateId}
                </Link>
              </section>
            )}
            <section className={styles.subSection}>
              <div className={styles.radioButtonGroup}>
                <label className={styles.label} htmlFor="period">
                  Recurring Cycle
                </label>
                <div className={`${styles.buttons} ${styles.checkboxVertical}`}>
                  <div>
                    <input
                      type="radio"
                      name="period"
                      value="weekly"
                      checked={form?.recurringDistribution?.period === 'weekly'}
                      onChange={handleRecurringUpdate}
                      disabled={drfType == DRF_TYPE.SCHEDULED}
                    />
                    <label htmlFor="weekly">Weekly (Scheduled payments begin the following week on Tuesday)</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="period"
                      value="monthly"
                      checked={form?.recurringDistribution?.period === 'monthly'}
                      onChange={handleRecurringUpdate}
                      disabled={drfType == DRF_TYPE.SCHEDULED}
                    />
                    <label htmlFor="monthly">Monthly</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="period"
                      value="quarterly"
                      checked={form?.recurringDistribution?.period === 'quarterly'}
                      onChange={handleRecurringUpdate}
                      disabled={drfType == DRF_TYPE.SCHEDULED}
                    />
                    <label htmlFor="quarterly">Quarterly</label>
                  </div>
                </div>
              </div>
            </section>
            {['quarterly', 'monthly'].includes(form?.recurringDistribution?.period) && (
              <section className={styles.subSection}>
                <div className={styles.formItemHalf}>
                  <label className={styles.label} htmlFor="dayRepeats">
                    Initiate Request on This Day of the Month
                  </label>
                  <div>
                    <select
                      className={styles.select}
                      name="dayRepeats"
                      value={form?.recurringDistribution?.dayRepeats || ''}
                      onChange={handleRecurringUpdate}
                      disabled={drfType == DRF_TYPE.SCHEDULED}
                      required
                    >
                      <option value="">Choose Day</option>
                      {[...new Array(31)].map((item, index) => (
                        <option key={`${index}-day-repeats-options`} value={index + 1}>
                          {index + 1}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </section>
            )}
            {['quarterly', 'monthly'].includes(form?.recurringDistribution?.period) && (
              <section className={styles.subSection}>
                <div className={styles.formItemMono}>
                  <label className={styles.label} htmlFor="startMonth">
                    Start Month
                  </label>
                  <div>
                    <select
                      className={styles.select}
                      name="startMonth"
                      value={form?.recurringDistribution?.startMonth || ''}
                      onChange={handleRecurringUpdate}
                      disabled={drfType == DRF_TYPE.SCHEDULED}
                      required
                    >
                      <option value="">Choose Day</option>
                      {MONTHS.map((item, index) => (
                        <option key={`${index}-start-month-options`} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </section>
            )}
            {form?.recurringDistribution?.period != null && (
              <section className={styles.subSection}>
                <div className={styles.formItemMono}>
                  <label className={styles.label} htmlFor="endDate">
                    End Date / Next Review Date
                  </label>
                  <DateInput
                    name="endDate"
                    value={form.recurringDistribution?.endDate}
                    onChange={handleRecurringUpdate}
                    onBlur={handleRecurringEndDateBlur}
                    disabled={isValidEndDate && (formDisabled || drfType == DRF_TYPE.SCHEDULED)}
                    min={endDateRange?.minEndDate}
                    max={endDateRange?.maxEndDate}
                    required
                  />
                </div>
              </section>
            )}
            <section className={styles.subSection}>
              <div className={styles.formItemMono}>
                <label className={styles.label} htmlFor="targetDay">
                  Due Date
                </label>
                <div>
                  <select
                    className={styles.select}
                    name="targetDay"
                    value={form?.recurringDistribution?.targetDay || ''}
                    onChange={handleRecurringUpdate}
                    disabled={drfType == DRF_TYPE.SCHEDULED}
                    required
                  >
                    <option value="">Choose Day</option>
                    {[...new Array(28)].map((item, index) => (
                      <option key={`${index}-day-repeats-options`} value={index + 1}>
                        {index + 1}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </section>
          </section>
        </section>
      )}
      {drfType == DRF_TYPE.TEMPLATE ? (
        <div className={styles.cardMarginBot}>
          <SectionHeader title="Related DRFs" />

          <section className={styles.sectionNoMargin}>
            <div className={styles.formItemHalf}>
              <div className={styles.associatedDrfTitle}>Paid distribution that initiated this requested recurring</div>
              <div className={styles.associatedDrf}>
                <p>{formatters.date(form.recurringDistribution.requestedFromDate)}</p>
                <Link
                  to={`/distributions/${form.recurringDistribution.requestedFromId}`}
                  className={styles.requestInfoItem}
                  target="_blank"
                  referrerPolicy="no-referrer"
                >
                  ID {form.recurringDistribution.requestedFromId}
                </Link>
              </div>
            </div>
            {form.recurringDistribution?.scheduledDistributions?.length > 0 && (
              <div className={styles.formItemHalf}>
                <div className={styles.scheduledDrfTitle}>Scheduled Payments from this Recurring Template</div>
                {form.recurringDistribution?.scheduledDistributions.map((scheduled) => (
                  <div className={styles.associatedDrfDate}>
                    <p>{formatters.date(scheduled)}</p>
                  </div>
                ))}
              </div>
            )}

            {form.status === 'recurring_approved' && (
              <div className={styles.payNowButton}>
                <p></p>
                <div>
                  <button type="button" className={styles.button} onClick={() => setPayNowRecurring(true)}>
                    <span>Pay Now</span>
                  </button>
                  <span>*Pay Now puts the next scheduled payment into the queue for immediate processing.</span>
                </div>
              </div>
            )}
          </section>
        </div>
      ) : (
        <section className={styles.cardMarginBot}>
          {!lockedForEdit && formDisabled && !['admin_wrapped_up'].includes(nextStatus) && <div className={styles.disabledMask}></div>}
          <SectionHeader title="Receive Info" />
          <section className={styles.sectionNoMargin}>
            <section className={styles.subSection}>
              <div className={styles.fileUpload}>
                <label className={styles.label}>Request Documents</label>
                <div className={styles.fileUploadComponent}>
                  <SimpleFileFolder
                    onUploadClick={onUploadClick}
                    files={files}
                    onDeleteClick={onDeleteClick}
                    disabledDelete={['paid', 'denied_closed'].includes(form.status)}
                  />
                </div>
              </div>
            </section>

            <section className={styles.subSection}>
              <div className={styles.formItemMono}>
                <label className={styles.label} htmlFor="dateReceived">
                  Date Received
                </label>
                <DateInput
                  name="dateReceived"
                  value={form.dateReceived}
                  onChange={updateForm}
                  disabled={formDisabled || disableFields || drfType == DRF_TYPE.SCHEDULED}
                  required
                />
              </div>
            </section>
            <section className={styles.subSection}>
              <div className={styles.formItemMono}>
                <label className={styles.label} htmlFor="account">
                  Account Number
                </label>
                <div className={styles.searchComponent}>
                  <AccountSearch
                    onAccountSelect={handleAccountSelect}
                    valueInsideInput={form.account && form.account.number ? `${form.account.number} - ${form.account.beneficiary}` : ''}
                    disabled={formDisabled || drfType == DRF_TYPE.SCHEDULED}
                  />
                </div>
              </div>
            </section>

            <section className={styles.subSection}>
              <div className={styles.formItemHalf}>
                <label className={styles.label} htmlFor="requestType">
                  Request Type
                </label>
                <div>
                  <select
                    className={styles.select}
                    name="requestType"
                    value={form.requestType || ''}
                    onChange={updateForm}
                    disabled={formDisabled || disableFields || drfType == DRF_TYPE.SCHEDULED}
                    required
                  >
                    <option value="">Choose Type</option>
                    <option value="automobile">Automobile</option>
                    <option value="entertainment">Entertainment</option>
                    <option value="food">Food</option>
                    <option value="housing">Housing</option>
                    <option value="insurance">Insurance</option>
                    <option value="misc">Misc</option>
                    <option value="services">Services</option>
                    <option value="utilities">Utilities</option>
                    <option value="credit_card">Credit Card</option>
                    <option value="reimburse">Reimbursement</option>
                    <option value="closing">Closing</option>
                    <option value="closing_deceased">Closing Deceased</option>
                  </select>
                </div>
              </div>
            </section>
            <section className={styles.subSection}>
              <div className={styles.radioButtonGroup}>
                <label className={styles.label} htmlFor="expeditedPaymentNeeded">
                  Expedited Payment Needed
                </label>
                <div className={styles.buttons}>
                  <input
                    type="radio"
                    name="expeditedPaymentNeeded"
                    value="yes"
                    checked={form.expeditedPaymentNeeded === 'yes'}
                    onChange={updateForm}
                    disabled={formDisabled || disableFields || drfType == DRF_TYPE.SCHEDULED}
                  />
                  <label htmlFor="yes">Yes</label>
                  <input
                    type="radio"
                    name="expeditedPaymentNeeded"
                    value="no"
                    checked={form.expeditedPaymentNeeded === 'no'}
                    disabled={disableFields || drfType == DRF_TYPE.SCHEDULED}
                    onChange={updateForm}
                  />
                  <label htmlFor="no">No</label>
                </div>
              </div>
            </section>
            {form.expeditedPaymentNeeded === 'yes' && (
              <section className={styles.subSection}>
                <div className={styles.formItemMono}>
                  <label className={styles.label} htmlFor="expeditedDateNeeded">
                    Expedited Payment Date Needed
                  </label>
                  <DateInput
                    name="expeditedDateNeeded"
                    value={form.expeditedDateNeeded}
                    onChange={updateForm}
                    disabled={formDisabled || disableFields || drfType == DRF_TYPE.SCHEDULED}
                    required
                  />
                </div>
              </section>
            )}
            {shouldShowReissuanceFee() && (
              <section className={styles.subSection}>
                <div className={styles.radioButtonGroup}>
                  <label className={styles.label} htmlFor="chargeReissuanceFee">
                    Charge Reissuance Fee
                  </label>
                  <div className={styles.buttons}>
                    <input
                      type="radio"
                      name="chargeReissuanceFee"
                      value="yes"
                      checked={form.chargeReissuanceFee === 'yes'}
                      onChange={updateForm}
                      disabled={formDisabled || disableFields || drfType == DRF_TYPE.SCHEDULED}
                    />
                    <label htmlFor="yes">Yes</label>
                    <input
                      type="radio"
                      name="chargeReissuanceFee"
                      value="no"
                      checked={form.chargeReissuanceFee === 'no'}
                      disabled={disableFields || drfType == DRF_TYPE.SCHEDULED}
                      onChange={updateForm}
                    />
                    <label htmlFor="no">No</label>
                  </div>
                </div>
              </section>
            )}
          </section>
        </section>
      )}
    </div>
  )
}